import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "headline-5" }, "Resources in your area", -1)
const _hoisted_2 = {
  class: "flex",
  style: {"justify-content":"space-between"}
}
const _hoisted_3 = {
  key: 0,
  class: "caption"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "FIND RESOURCES", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_region_selector = _resolveComponent("region-selector")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_contact_list_item = _resolveComponent("contact-list-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Selected Region:"))
        : _createCommentVNode("", true),
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_region_selector, { key: 1 }))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.myRegion && !_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_item, { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-text-center ion-text-wrap" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loading ? "loading.." : "Find resources in your local region"), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, { lines: "none" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/home/contacts'))),
                  color: "primary",
                  class: "my-pointer no-corners auto"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ion_list, { key: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mocks, (block) => {
                return (_openBlock(), _createBlock(_component_ion_item, {
                  lines: "none",
                  key: block + '-block'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_thumbnail, { slot: "end" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_skeleton_text, { style: {"border-radius":"50%"} })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, [
                          _createVNode(_component_ion_skeleton_text, { style: {"width":"50%"} })
                        ]),
                        _createElementVNode("p", null, [
                          _createVNode(_component_ion_skeleton_text, { style: {"width":"40%"} })
                        ]),
                        _createElementVNode("p", null, [
                          _createVNode(_component_ion_skeleton_text, { style: {"width":"70%"} })
                        ]),
                        _createElementVNode("p", null, [
                          _createVNode(_component_ion_skeleton_text, { style: {"width":"80%"} })
                        ]),
                        _createElementVNode("p", null, [
                          _createVNode(_component_ion_skeleton_text, { style: {"width":"80%"} })
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.myRegion)
      ? (_openBlock(), _createBlock(_component_ion_list, { key: 2 }, {
          default: _withCtx(() => [
            (_ctx.contacts && _ctx.contacts.length == 0)
              ? (_openBlock(), _createBlock(_component_ion_item, {
                  key: 0,
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" No " + _toDisplayString(_ctx.category ? _ctx.category : _ctx.lowestCategoryName ? _ctx.lowestCategoryName : '') + " resources found in selected region. ", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (contact) => {
              return (_openBlock(), _createBlock(_component_contact_list_item, {
                class: "my-1",
                contact: contact,
                onGoto: ($event: any) => {_ctx.$store.dispatch('contact/getContact', contact.id); _ctx.$router.push('/home/contacts/' + contact.id)},
                key: contact.id + '-contact'
              }, null, 8, ["contact", "onGoto"]))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}